import { z } from 'zod';
import { accountDetailsResponseSchema } from './accountDetailsStep.js';
import { companyDataStepSchema } from './companyDataStep.js';
import { onboardingApplicationStatusSchema, onboardingStepSchema } from './onboardingApplication.js';
import { registrationChannelSchema } from './registrationChannelStep.js';
import { validationResponseSchema } from './validationStep.js';
import { workAreaStepSchema } from './workAreaStep.js';
import { workCategoriesStepSchema } from './workCategoriesStep.js';
export const onboardingApplicationResponseSchema = z.object({
    uuid: z.uuid(),
    status: onboardingApplicationStatusSchema,
    currentStep: onboardingStepSchema,
    email: z.email(),
    companyUid: z.string().optional(),
    workCategories: workCategoriesStepSchema.optional(),
    workArea: workAreaStepSchema.optional(),
    accountDetails: accountDetailsResponseSchema.optional(),
    companyData: companyDataStepSchema.optional(),
    validation: validationResponseSchema.optional(),
    registrationChannel: registrationChannelSchema.optional(),
});
